<template>
  <div>
    <router-view />
    <ScrollTopProgress />
    <!-- Global confirm modal instance bound to composable state -->
    <ConfirmModal
      v-model="showConfirm"
      type="delete"
      :title="confirmTitle"
      :message="confirmMessage"
      :confirm-text="confirmConfirmText"
      :cancel-text="confirmCancelText"
      @confirm="() => handleConfirm(true)"
      @cancel="() => handleConfirm(false)"
    />
    <AlertModal
      v-model="alertModel"
      :message="alertState.message"
      :type="alertState.type"
      :title="alertState.title"
      :type-label="alertState.typeLabel"
      :link="alertState.link"
      :alertcode="alertState.alertcode"
    />
    <LicenseAccessWarningModal v-model="showLicenseWarning" :days-left="licenseDaysLeft" @renew="renewLicense" />
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ConfirmModal from './components/UiCompunents/ConfirmModal.vue';
import AlertModal from './components/Common/AlertModal.vue';
import LicenseAccessWarningModal from './components/Common/LicenseAccessWarningModal.vue';
import ScrollTopProgress from './components/Common/ScrollTopProgress.vue';
import { useConfirm } from './stores/composables.js';
import { useAlertModal } from './stores/alertModal.js';
import { useUserAreaStore } from './stores/common/userArea.js';
import apiClient from './axios';
import { daysUntilLicenseExpiry } from './utils/licenseStatus';
const { showConfirm, confirmMessage, confirmTitle, confirmConfirmText, confirmCancelText, onConfirm } = useConfirm()
const { alertState, closeAlert } = useAlertModal()
const route = useRoute();
const router = useRouter();
const userAreaStore = useUserAreaStore();
const showLicenseWarning = ref(false);
const licenseDaysLeft = ref(null);
let licenseRequestId = 0;

const alertModel = computed({
  get: () => alertState.show,
  set: (value) => {
    if (!value) closeAlert()
  },
})

function handleConfirm(val) {
  onConfirm(val)
}

async function checkCompanyLicense(path) {
  const requestId = ++licenseRequestId;
  showLicenseWarning.value = false;
  licenseDaysLeft.value = null;
  if (path !== '/overview/ESF/EStatement') return;
  const token = localStorage.getItem('token');
  if (!token) return;
  try {
    const { data } = await apiClient.get(`/LoginInformation/GetLoginInformation?isMaster=${localStorage.getItem('ismaster')}`);
    if (requestId !== licenseRequestId || localStorage.getItem('token') !== token) return;
    const days = daysUntilLicenseExpiry(data?.licenseInfo?.expireDate);
    if (days === null) return;
    licenseDaysLeft.value = days;
    showLicenseWarning.value = days <= 15;
  } catch (error) {
    console.warn('Company license expiry could not be checked:', error);
  }
}

function renewLicense() {
  userAreaStore.renewLicense();
  if (route.path !== '/overview/common/user-area') router.push('/overview/common/user-area');
}

watch(() => route.path, checkCompanyLicense, { immediate: true });
</script>
<style></style>
